import { useQueryClient } from '@tanstack/react-query';
import { useAuth } from '@/contexts/AuthContext';
import { useCrmWebSocket } from '@/hooks/useCrmWebSocket';

/** Refreshes lead list/detail when Sales CRM mobile logs a call (WebSocket). */
export default function CrmLeadActivitySync() {
  const { user } = useAuth();
  const queryClient = useQueryClient();
  const role = String(user?.role ?? '').toUpperCase();
  const enabled =
    !!user &&
    (role === 'SALES_PERSON' ||
      role === 'SALES_MANAGER' ||
      role === 'HOSPITAL_ADMIN' ||
      role === 'SUPER_ADMIN');

  useCrmWebSocket({
    enabled,
    onLeadActivity: (leadId) => {
      queryClient.invalidateQueries({ queryKey: ['leads'] });
      queryClient.invalidateQueries({ queryKey: ['lead', leadId] });
    },
  });

  return null;
}
